import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getVehicles = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/vehicles/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicles fetch error:", error);
    throw error;
  }
};

const getVehicleById = async (id, period) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/vehicles/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params: period ? { period } : undefined,
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicle fetch error:", error);
    throw error;
  }
};

const updateVehicle = async (id, data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/vehicles/?id=${id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicle update error:", error);
    throw error;
  }
};

const updateVehicleStatus = async (id, data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/vehicles/status/?id=${id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicle status update error:", error);
    throw error;
  }
};

const deleteVehicle = async (id) => {
  try {
    const token = getToken();

    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/vehicles/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicle delete error:", error);
    throw error;
  }
};

const createVehicle = async (data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/vehicles/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicle create error:", error);
    throw error;
  }
};

const getFuelTypes = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}lookups/fuel-types/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel types lookup error:", error);
    throw error;
  }
};

const getAvailableFuelCards = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/fuel-cards/available`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Available fuel cards fetch error:", error);
    throw error;
  }
};

const getVehicleDocumentTypes = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/vehicles/document-types/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicle document types fetch error:", error);
    throw error;
  }
};

const getVehicleTypes = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/vehicles/vehicle-types/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicle types fetch error:", error);
    throw error;
  }
};

const getNavixyApiKeys = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/vehicles/navixy-api-keys/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Navixy API keys fetch error:", error);
    throw error;
  }
};

// vehicleId (Edit page only) keeps that vehicle's own linked tracker in the
// list -- the backend otherwise hides every already-linked tracker.
const getNavixyOdometer = async (apiKey, trackerId) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/vehicles/navixy-odometer/`,
      {
        params: { api_key: apiKey, tracker_id: trackerId },
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Navixy odometer fetch error:", error);
    throw error;
  }
};

const getNavixyTrackers = async (apiKey, vehicleId) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/vehicles/navixy-trackers/`,
      {
        params: {
          api_key: apiKey,
          ...(vehicleId ? { vehicle_id: vehicleId } : {}),
        },
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Navixy trackers fetch error:", error);
    throw error;
  }
};

const deleteVehicleDocument = async (documentId) => {
  try {
    const token = getToken();

    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}documents/?id=${documentId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Vehicle document delete error:", error);
    throw error;
  }
};

export {
  getNavixyApiKeys,
  getNavixyTrackers,
  getNavixyOdometer,
  getVehicleTypes,
  getVehicles,
  getVehicleById,
  updateVehicle,
  updateVehicleStatus,
  deleteVehicle,
  createVehicle,
  getFuelTypes,
  getAvailableFuelCards,
  getVehicleDocumentTypes,
  deleteVehicleDocument,
};
